<div class="dialog">
  <h2 mat-dialog-title class="header">
    <span class="title">{{ 'sebbie_ranking.dialog_task' | translate }} {{tasknumber}}</span>
    <button class="close-ref" mat-icon-button (click)="close()" [title]="'general.close' | translate | titlecase">
      <mat-icon>clear</mat-icon>
    </button>
  </h2>
  <div mat-dialog-content>
    <div class="top">
      <div class="completed-count">
        <h3>{{ "sebbie_ranking.dialog_times_completed" | translate}}</h3>
        <div class="wrapper">
            <mat-icon [ngClass]="{
              'completed': completedCount > 0
            }">{{ completedCount > 0 ? 'check_circle' : 'cancel'}}</mat-icon><span>{{completedCount}}</span>
          </div>
        </div>
        <div class="reward">
          <h3>{{ "sebbie_ranking.dialog_reward" | translate}}</h3>
          <div class="wrapper">
            <img
              src="assets/images/sebbies/Spots-3.png"
              alt="Sebbies"
              />
              @if (task.reward) {
                <span>+ {{task.reward * completedCount || 0}}</span>
              }
            </div>
          </div>
        </div>
        <div class="description">
          <h3>{{task.title}}</h3>
          <p>{{task.description}}</p>
        </div>
      </div>
      <div mat-dialog-actions class="dialog-button-end">
        <button class="close-ref cancel" mat-flat-button color="primary" [title]="'general.close' | translate | titlecase" (click)="close()">
          {{ 'general.close' | translate}}
        </button>
      </div>
    </div>
